export default "__VITE_ASSET__DXqr20oI__"